<template>
  <svg
    t="1658802400340"
    class="icon inline-block"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="11226"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
  >
    <path
      d="M159 587.884c0 112.79 66.936 214.826 170.396 259.746l163.833 71.134a40 40 0 0 0 33.73-0.87l164.843-81.903C797.905 783.273 865 675.015 865 556.538V195.796c-52.55-4.556-104.182-10.416-154.895-17.582-65.758-9.292-131.636-35.853-197.568-79-63.96 42.81-130.287 69.34-198.642 79-52.516 7.421-104.148 13.318-154.895 17.69v391.98z m-32.263-449.565c58.33-4.412 117.918-10.917 178.763-19.515 62.633-8.85 123.933-34.342 183.901-76.473a40 40 0 0 1 45.563-0.296c62.52 42.724 123.7 68.314 183.536 76.77 58.33 8.242 117.937 14.723 178.819 19.442C912.94 139.46 925 152.488 925 168.157v388.381c0 141.258-79.996 270.332-206.5 333.186l-164.844 81.904a100 100 0 0 1-84.322 2.172L305.5 902.666C180.119 848.228 99 724.573 99 587.884v-419.65c0-15.69 12.091-28.731 27.737-29.915z"
      fill="#2F54EB"
      p-id="11227"
    ></path>
    <path
      d="M441.399 593.511l237.865-237.287c13.673-13.64 35.83-13.631 49.491 0.02 13.667 13.655 13.659 35.789-0.019 49.433L466 667.776c-13.718 13.685-35.964 13.624-49.607-0.136L295.129 545.34c-13.603-13.72-13.49-35.853 0.251-49.433 13.737-13.575 35.893-13.463 49.491 0.252L441.4 593.51z"
      fill="#85A5FF"
      p-id="11228"
    ></path>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ type: String, default: '#FFFFFF' }) color!: String;
}
</script>
